import { ethers } from 'ethers';
import { USDT_DECIMALS } from '../config/contracts';

export const fromUSDT = (raw) => {
  if (raw == null) return '0';
  try { return ethers.utils.formatUnits(raw.toString(), USDT_DECIMALS); }
  catch { return '0'; }
};

export const toUSDT = (val) => {
  try { return ethers.utils.parseUnits(val.toString(), USDT_DECIMALS); }
  catch { return ethers.BigNumber.from(0); }
};

export const fmtUSDT = (raw, fixed = 2) => {
  const v = parseFloat(fromUSDT(raw));
  if (isNaN(v)) return '0.00';
  if (v === 0) return '0.00';
  if (v < 0.01) return v.toFixed(6);
  return v.toLocaleString('en-US', { maximumFractionDigits: fixed, minimumFractionDigits: fixed });
};

export const fmtNum = (n) => {
  const v = Number(n || 0);
  return v.toLocaleString('en-US');
};

export const shortAddr = (addr, n = 4) => {
  if (!addr) return '';
  const s = addr.toString();
  if (s.length < n * 2 + 2) return s;
  return s.slice(0, n + 2) + '...' + s.slice(-n);
};

export const fmtTime = (ts) => {
  if (!ts) return '-';
  const ms = Number(ts) * 1000;
  if (!ms) return '-';
  const d = new Date(ms);
  return d.toLocaleString();
};

export const fmtAgo = (ts) => {
  if (!ts) return '-';
  const sec = Math.floor(Date.now() / 1000) - Number(ts);
  if (sec < 60) return `${sec}s ago`;
  if (sec < 3600) return `${Math.floor(sec / 60)}m ago`;
  if (sec < 86400) return `${Math.floor(sec / 3600)}h ago`;
  return `${Math.floor(sec / 86400)}d ago`;
};

export const positionLetter = (pos) => {
  const p = Number(pos || 0);
  if (p <= 0) return '-';
  if (p > 26) return `#${p}`;
  return String.fromCharCode(64 + p); // 1->A, 2->B, ...
};
